<woa-modal-page-layout [title]="'woa.heading.edit-profile.title'">
    @if (!identityModel.isGuestUser() && !editingCustomer()) {
        <div class="label">{{ 'woa.heading.edit-profile.member-card' | translate }}</div>
        <woa-member-card-panel></woa-member-card-panel>
        <div class="links">
            @if (!editingMember() && !editingCustomer()) {
                <woa-link class="links-edit-details"
                          [link]="canEditMember() ? 'woa.button.profile.editMember' : 'woa.button.profile.showMore'"
                          (onActivate)="editingMember.set(true)"></woa-link>
            }
        </div>
    }
    @if ((customerDetails()?.populated || authenticatedCustomerContactDetails()?.populated) && !editingMember()) {
        <div class="label">{{ 'woa.heading.edit-profile.customer-details' | translate }}</div>
        <woa-customer-details-panel [customerDetails]="customerDetails()"
                                    [authenticatedCustomerContactDetails]="authenticatedCustomerContactDetails()"></woa-customer-details-panel>
        <div class="links">
            @if (!editingMember() && !editingCustomer()) {
                <woa-link class="links-forget-details"
                          [link]="'woa.button.profile.forgetCustomer'"
                          (onActivate)="forgetCustomer()"></woa-link>
            }
            @if (customerDetails()?.populated && !editingMember() && !editingCustomer()) {
                <woa-link class="links-edit-details"
                          [link]="'woa.button.profile.editCustomer'"
                          (onActivate)="editingCustomer.set(true)"></woa-link>
            }
        </div>
    }
    @if (editingMember() || editingCustomer()) {
        <woa-form (onSubmit)="saveProfile()">
            @if (editingMember()) {
                <woa-field-pair>
                    <woa-text-field [(ngModel)]="identityEntityModel.data.firstName" name="firstName"
                                    [label]="'woa.label.common.firstName'"
                                    required [maxlength]="'30'" [readOnly]="!canEditMember()"
                                    [autocomplete]="'given-name'" [spellcheck]="false"></woa-text-field>
                    <woa-text-field [(ngModel)]="identityEntityModel.data.lastName" name="lastName"
                                    [label]="'woa.label.common.lastName'"
                                    required [maxlength]="'30'" [readOnly]="!canEditMember()"
                                    [autocomplete]="'family-name'" [spellcheck]="false"></woa-text-field>
                </woa-field-pair>
                <woa-email-field [(ngModel)]="memberEmail" name="email"
                                 [label]="'woa.label.common.email'" required woa-email
                                 [readOnly]="!canEditMember() || authService.getLoggedInType() == LoginType.MEMBER_EMAIL"></woa-email-field>
                <woa-phone-number-field [(ngModel)]="identityEntityModel.data.mobilePhone" name="mobilePhone"
                                        [label]="'woa.label.common.mobile'" required woa-phone-number
                                        [readOnly]="!canEditMember() || authService.getLoggedInType() == LoginType.MEMBER_MOBILE || authService.getLoggedInType() == LoginType.MEMBER_NO_PLUS_MOBILE"></woa-phone-number-field>
                @if (!canEditMember() && identityEntityModel.data.dob) {
                    <woa-date-field [(ngModel)]="identityEntityModel.data.dob" name="dob"
                                    [label]="'woa.label.common.dob'" [readOnly]="true"></woa-date-field>
                }
                @if (canEditMember()) {
                    <woa-field-pair>
                        <woa-date-field [(ngModel)]="identityEntityModel.data.dob" name="dob"
                                        [label]="'woa.label.common.dob'"></woa-date-field>
                        <woa-selection-field [(ngModel)]="identityEntityModel.data.gender" name="gender"
                                             [label]="'woa.label.common.gender'">
                            <woa-option [value]="1" [label]="'woa.label.common.female'"></woa-option>
                            <woa-option [value]="0" [label]="'woa.label.common.male'"></woa-option>
                        </woa-selection-field>
                    </woa-field-pair>
                    <woa-text-field [(ngModel)]="identityEntityModel.data.homeAddress.street" name="street"
                                    [label]="'woa.label.address.street'" [maxlength]="'60'"
                                    [autocomplete]="'street-address'" [spellcheck]="false"></woa-text-field>
                    <woa-text-field [(ngModel)]="identityEntityModel.data.homeAddress.city" name="city"
                                    [label]="'woa.label.address.suburb'" [maxlength]="'30'"
                                    [autocomplete]="'address-level2'" [spellcheck]="false"></woa-text-field>
                    <woa-field-pair>
                        <woa-text-field [(ngModel)]="identityEntityModel.data.homeAddress.state" name="state"
                                        [label]="'woa.label.address.state'" [maxlength]="'35'"
                                        [autocomplete]="'address-level1'" [spellcheck]="false"></woa-text-field>
                        <woa-text-field [(ngModel)]="identityEntityModel.data.homeAddress.postCode" name="postCode"
                                        [label]="'woa.label.address.postCode'" [maxlength]="'10'"
                                        [autocomplete]="'postal-code'" [spellcheck]="false"></woa-text-field>
                    </woa-field-pair>
                    <woa-text-area-field [(ngModel)]="identityEntityModel.data.deliveryInstructions"
                                         name="deliveryInstructions"
                                         [label]="'woa.label.address.deliveryInstructions'"
                                         [maxlength]="'255'"></woa-text-area-field>
                }
            }
            @if (editingCustomer()) {
                <woa-field-pair>
                    <woa-text-field [(ngModel)]="customerDetails().firstName" name="firstName"
                                    [label]="'woa.label.common.firstName'"
                                    required [maxlength]="'30'"
                                    [autocomplete]="'given-name'" [spellcheck]="false"></woa-text-field>
                    <woa-text-field [(ngModel)]="customerDetails().lastName" name="lastName"
                                    [label]="'woa.label.common.lastName'"
                                    required [maxlength]="'30'"
                                    [autocomplete]="'family-name'" [spellcheck]="false"></woa-text-field>
                </woa-field-pair>
                <woa-email-field [(ngModel)]="customerEmail" name="email"
                                 [label]="'woa.label.common.email'" woa-email></woa-email-field>
                <woa-phone-number-field [(ngModel)]="customerDetails().mobilePhone" name="mobilePhone"
                                        [label]="'woa.label.common.mobile'" woa-phone-number></woa-phone-number-field>
            }
        </woa-form>
    }
    @if ((editingMember() && canEditMember()) || editingCustomer()) {
        <woa-button woa-page-footer-control
                    [label]="'woa.button.common.save'" id="button-save-profile" (onActivate)="form()?.submit()"></woa-button>
    }
</woa-modal-page-layout>
